import * as React from 'react'
// import * as Assets from '../../../assets/Assets'
// import { Main } from '../../../Logic/Main'
// import * as Config from '../../../Logic/Config'
import Body from './Body'
import { Footer, HowToPlay, Contact, Privacy, Terms } from './Footer'
import Lounge from './Lounge'
import { Bet1, Bet2, Bet3, Confirmation, Inserting } from './Bet'
import { Leaderboards } from './Leaderboards'
import Leagues from './Leagues'
import Standings from './Standings'
import { MyProfile } from './MyProfile'
import { subscribe } from '../../../Socket/statelogic'
import Socket from '../../../Socket/socket-init'
import SocketState from '../../../Socket/socketstate'
// import axios from 'axios'
// import { Logic } from '../../../Logic/Type'
import Results from './Results'
import Login from './Login'
import SignUp from './SignUp'
// import * as Utils from '../../../Logic/Utils'
import { Route, Switch } from 'react-router-dom'
// import { instanceOf } from 'prop-types'
import { Cookies, withCookies } from 'react-cookie'
import Unsubscribe from './Unsubscribe';

/*
function getSubDomain() {
    const url = window.location.hostname
    return url.split('.')[0]
}
*/

@subscribe(SocketState)
class Fantasy extends React.Component<{location: any}, {}> {

    cookies = new Cookies()

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        /*if (Main.Instance.Fantasy.countries === undefined) {
            axios.get(Config.asFlags).then((response) => {
                Logic.Type.New (Main.Instance.Fantasy, {countries: response.data})
            })
        }*/
        Socket.onOpen = () => {
            // Socket.Send('flags', {})
        }
    }

    render() {
        return (
            <React.Fragment>
                <Switch>
                    <Route path="/signup" component={SignUp} />
                    <Route path="/login" component={Login} />
                    <Route path="/lounge" component={Lounge} />
                    <Route path="/results" component={Results} />
                    <Route path="/betstep1" component={Bet1} />
                    <Route path="/betstep2" component={Bet2} />
                    <Route path="/betstep3" component={Bet3} />
                    <Route path="/confirmation" component={Confirmation} />
                    <Route path="/leaderboards" component={Leaderboards} />
                    <Route path="/inserting" component={Inserting} />
                    <Route path="/leagues" component={Leagues} />
                    <Route path="/missionstatement" component={HowToPlay} />
                    <Route path="/contact" component={Contact} />
                    <Route path="/howtoplay" component={HowToPlay} />
                    <Route path="/support" component={HowToPlay} />
                    <Route path="/termsandconditions" component={Terms} />
                    <Route path="/privacypolicy" component={Privacy} />
                    <Route path="/standings" component={Standings} />
                    <Route path="/myprofile" component={MyProfile} />
                    <Route path="/unsubscribe" component={Unsubscribe}/>
                    <Route path="/" component={Body} />
                </Switch>
                {(window.location.pathname !== '/') ? <Footer/> : null}
            </React.Fragment>
        )
    }
}

export default withCookies(Fantasy)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Fantasy.tsx